module.exports = __webpack_public_path__ + "static/media/80.4b475c09.jpg";